import { render } from "./Prayers.vue?vue&type=template&id=1b815d9e"
import script from "./Prayers.vue?vue&type=script&lang=js"
export * from "./Prayers.vue?vue&type=script&lang=js"
script.render = render

export default script